import { playVideo as requestVideoPlayback, pauseVideo } from './autoplayVideos.js';

export function projectVideo(root = document) {
    const cards = root.matches?.('.project-card')
        ? [root]
        : root.querySelectorAll('.project-card');

    cards.forEach((card) => {
        if (card.dataset.videoInitialized === 'true') return;

        const video = card.querySelector('.project-card__video');

        if (!video) return;

        card.dataset.videoInitialized = 'true';

        card.addEventListener('mouseenter', () => {
            requestVideoPlayback(video);
        });

        card.addEventListener('mouseleave', () => {
            pauseVideo(video);
            video.currentTime = 0;
        });
    });
}
